// extracted by mini-css-extract-plugin
module.exports = {"searchResultContainer":"SearchResult_searchResultContainer__Iuj_H","courseSearchInputContainer":"SearchResult_courseSearchInputContainer__2ec61"};